import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const Candidatos = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_candidatos, setLoadingcandidatos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [candidatos, setcandidatos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { faculdade_id, faculdade_name, slug } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [candidato_id, setcandidatoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getcandidatos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_candidatos/${faculdade_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setcandidatos(response.alunos);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingcandidatos(false);


    }
  };

  const Deletecandidato = async (candidato_id) => {

    let response = await Request.Delete(`faculdade/delete_candidato/${candidato_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getcandidatos(pagination.current_page, search_oficial);



  };
  const user = useSelector((state) => state.AppReducer.user);

  useEffect(() => {
    Getcandidatos(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{`
                            ${t("candidates")}
                        `}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{`
                                ${t("candidates")}
                            `}</h3>

                            <p>
                                {user.empresa == null || user.empresa.change_text == false ? t("legacy_gerencie_os_candidatos_da_instituicao") : t("legacy_gerencie_os_candidatos_do_processo")

                }.
                               
                            </p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>

                    {user?.empresa?.online_proccess === true &&

          <div
            className="process-info-card"
            style={{
              marginBottom: '24px'
            }}>


                            <div className="icon green">
                                🔗
                            </div>

                            <div style={{ flex: 1 }}>

                                <span>
                                    {t("portal_candidate")}
                                </span>

                                <strong
                style={{
                  wordBreak: 'break-all'
                }}>

                                    <a
                  href={`https://candidato.ontest.com.br/${slug}/login`}
                  target="_blank"
                  rel="noopener noreferrer">

                                        {`https://candidato.ontest.com.br/${slug}/login`}
                                    </a>
                                </strong>

                            </div>

                        </div>

          }

                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_pelo_nome_do_candidato")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingcandidatos(true);

                  Getcandidatos(1, value);

                }, 500);

              }} />


                        {(user.role === 'region_admin' ||
            user.empresa == null || user.empresa.can_add) &&

            <Link
              to={`/candidatos/register/${faculdade_id}`}
              className="btn-module-primary">


                                    <FaListAlt />{`

                                    ${t("legacy_adicionar_candidato")}

                                `}</Link>

            }

                    </div>

                    <div className="table-modern-card">

                        <table
              id="tech-companies-1"
              className="table table-striped">


                            <thead>

                                <tr>

                                    <th>{t("label_name")}</th>

                                    <th>{t("label_email")}</th>

                                    <th>{t("legacy_cpf")}</th>

                                    <th>Primeiro Login</th>

                                    <th>Nascimento</th>

                                    {(user.role === 'region_admin' ||
                  user.empresa == null ||
                  user.empresa.can_exclude ||
                  user.empresa.can_edit) &&

                  <th>{t("label_actions")}</th>

                  }

                                </tr>

                            </thead>

                            <tbody>

                                {!loading_candidatos &&
                candidatos.map((item, id) =>

                <tr key={id}>

                                            <td>

                                                <strong>
                                                    {item.name}
                                                </strong>

                                            </td>

                                            <td>
                                                {item.email}
                                            </td>

                                            <td>
                                                {item.cpf}
                                            </td>

                                            <td>

                                                {item.first_last == null ?

                    <span
                      className="trust-badge trust-high">

                                                        Nunca acessou
                                                    </span> :



                    <span
                      className="trust-badge trust-low">

                                                        {moment(
                        item.first_last.first,
                        'YYYY-MM-DD'
                      ).format(
                        'DD/MM/YYYY'
                      )}
                                                    </span>

                    }

                                            </td>

                                            <td>

                                                {moment(
                      item.nascimento,
                      'YYYY-MM-DD'
                    ).format(
                      'DD/MM/YYYY'
                    )}

                                            </td>

                                            {(user.role === 'region_admin' ||
                  user.empresa == null ||
                  user.empresa.can_exclude ||
                  user.empresa.can_edit) &&

                  <td>

                                                        <div className="actions-group">

                                                            {(user.role === 'region_admin' ||
                      user.empresa == null ||
                      user.empresa.can_edit) &&

                      <Link
                        to={`/candidatos/edit/${item.id}`}>


                                                                        <button
                          className="action-btn info"
                          title={t("legacy_editar_candidato")}>

                                                                            <MdModeEdit />
                                                                        </button>

                                                                    </Link>

                      }

                                                            {(user.role === 'region_admin' ||
                      user.empresa == null ||
                      user.empresa.can_exclude) &&

                      <button
                        className="action-btn danger"
                        title={t("legacy_excluir_candidato")}
                        onClick={() => {

                          setcandidatoId(
                            item.id
                          );

                          setShowWarning(
                            true
                          );

                        }}>


                                                                        <MdDelete />

                                                                    </button>

                      }

                                                        </div>

                                                    </td>

                  }

                                        </tr>

                )}

                            </tbody>

                        </table>

                        {loading_candidatos &&

            <div className="row m-0">

                                <div className="col-12 d-flex justify-content-center align-items-center">

                                    <CircularProgress />

                                </div>

                            </div>

            }

                    </div>

                    {!loading_candidatos &&
          candidatos.length === 0 &&

          <div className="empty-module">

                                <div className="empty-module-icon">
                                    👥
                                </div>

                                <h3>{`
                                    ${t("empty_no_candidate_found")}
                                `}</h3>

                                <p>
                                    {user.empresa == null || user.empresa.change_text == false ?
              'Cadastre o primeiro candidato desta instituição.' :
              'Cadastre o primeiro candidato deste processo.'}.
                                </p>

                            </div>

          }

                    <Pagination
            className={
            pagination.last_page === 1 ?
            "hide" :
            ""
            }
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px"
            }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {

              setLoadingcandidatos(true);

              let page = { ...pagination };

              page.current_page = value;

              setPagination(page);

              Getcandidatos(
                value,
                search_oficial
              );

            }} />


                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingcandidatos(true);
            Deletecandidato(candidato_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_este_candidato_ele_nao_estara_mais_disp_014976fb")}


        </SweetAlert>


            </div>

        </div>);

};

export default Candidatos;
